{
  "nav": {
    "features": "الميزات",
    "formats": "الأنظمة",
    "screenshots": "لقطات",
    "download": "تحميل",
    "openSource": "مفتوح المصدر",
    "github": "GitHub"
  },
  "hero": {
    "title": "SaiPair",
    "subtitle": "برنامج مجاني لإدارة البطولات",
    "description": "تطبيق سطح مكتب مفتوح المصدر يعمل بدون إنترنت لتنظيم البطولات. النظام السويسري، الدوري، خروج المغلوب والمزيد.",
    "download": "تحميل الآن",
    "viewOnGithub": "عرض على GitHub"
  },
  "features": {
    "title": "الميزات",
    "subtitle": "كل ما تحتاجه لإدارة بطولة",
    "f1_title": "أنظمة متعددة",
    "f1_desc": "النظام السويسري، الدوري، الدوري المزدوج، خروج المغلوب الفردي والمزدوج.",
    "f2_title": "مقارعة تلقائية",
    "f2_desc": "محرك ذكي ينشئ المقارعات فوراً.",
    "f3_title": "ترتيب مباشر",
    "f3_desc": "ترتيب محدث لحظياً مع قواعد فض التعادل.",
    "f4_title": "بدون إنترنت",
    "f4_desc": "لا حاجة للإنترنت. البيانات مخزنة محلياً.",
    "f5_title": "استيراد وتصدير",
    "f5_desc": "استيراد اللاعبين من Excel/CSV. تصدير الترتيب والمقارعات.",
    "f6_title": "جاهز للطباعة",
    "f6_desc": "طباعة القوائم والمقارعات والترتيب.",
    "f7_title": "متعدد اللغات",
    "f7_desc": "متوفر بـ 10 لغات.",
    "f8_title": "مجاني ومفتوح المصدر",
    "f8_desc": "رخصة MIT، مجاني للأبد."
  },
  "formats": {
    "title": "أنظمة البطولات",
    "subtitle": "اختر النظام المناسب",
    "swiss_title": "النظام السويسري",
    "swiss_desc": "يجمع لاعبين بنقاط متقاربة في كل جولة.",
    "roundRobin_title": "الدوري",
    "roundRobin_desc": "كل لاعب يواجه جميع اللاعبين الآخرين.",
    "elimination_title": "خروج المغلوب",
    "elimination_desc": "الخاسرون يُقصون في كل جولة.",
    "doubleElim_title": "خروج المغلوب المزدوج",
    "doubleElim_desc": "يحصل اللاعبون على فرصة ثانية."
  },
  "screenshots": {
    "title": "لقطات الشاشة",
    "subtitle": "شاهد SaiPair أثناء العمل",
    "placeholder": "لقطات الشاشة قريباً — حمّل وجرّب بنفسك!"
  },
  "download": {
    "title": "تحميل",
    "subtitle": "متوفر لـ Windows و macOS و Linux",
    "windows": "Windows",
    "macos": "macOS",
    "linux": "Linux",
    "getLatest": "تحميل أحدث إصدار",
    "allReleases": "عرض جميع الإصدارات"
  },
  "openSource": {
    "title": "مفتوح المصدر",
    "subtitle": "تطوير مفتوح، رخصة MIT",
    "description": "SaiPair برنامج مجاني ومفتوح المصدر. الجميع مرحب بهم للمساهمة.",
    "github": "مستودع GitHub",
    "issues": "الإبلاغ عن مشاكل",
    "discussions": "الانضمام للنقاشات"
  },
  "footer": {
    "copyright": "© {{year}} SaiPair. رخصة MIT.",
    "madeWith": "صُنع بـ ❤ لمنظمي البطولات حول العالم."
  },
  "language": {
    "en": "English",
    "zh-CN": "中文",
    "es": "Español",
    "fr": "Français",
    "pt": "Português",
    "ru": "Русский",
    "ja": "日本語",
    "ar": "العربية",
    "hi": "हिन्दी",
    "bn": "বাংলা"
  }
}
